// /var/www/oszczedzam/client/src/components/reports/ReportFilters.js
import React, { useState } from 'react';
import { 
  Box, Paper, Typography, Grid, FormControl, InputLabel, 
  Select, MenuItem, Button, Chip, Autocomplete, TextField
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { pl } from 'date-fns/locale';
import { FilterList as FilterListIcon } from '@mui/icons-material';

function ReportFilters({ filters, onFilterChange, availableCategories }) {
  const [showFilters, setShowFilters] = useState(true);
  const currentYear = new Date().getFullYear();
  
  // Generuj lata do wyboru (5 lat wstecz)
  const years = Array.from({ length: 6 }, (_, i) => currentYear - i);
  
  // Generuj miesiące
  const months = [
    { value: 0, label: 'Styczeń' },
    { value: 1, label: 'Luty' },
    { value: 2, label: 'Marzec' },
    { value: 3, label: 'Kwiecień' },
    { value: 4, label: 'Maj' },
    { value: 5, label: 'Czerwiec' },
    { value: 6, label: 'Lipiec' },
    { value: 7, label: 'Sierpień' },
    { value: 8, label: 'Wrzesień' },
    { value: 9, label: 'Październik' },
    { value: 10, label: 'Listopad' },
    { value: 11, label: 'Grudzień' }
  ];

  // Przełącz widoczność filtrów
  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  // Obsługa zmiany okresu
  const handlePeriodChange = (event) => {
    onFilterChange({ period: event.target.value });
  };

  // Obsługa zmiany roku
  const handleYearChange = (event) => {
    onFilterChange({ year: event.target.value });
  };

  // Obsługa zmiany miesiąca
  const handleMonthChange = (event) => {
    onFilterChange({ month: event.target.value });
  };
  
  // Obsługa zmiany typu porównania
  const handleCompareWithChange = (event) => {
    onFilterChange({ compareWith: event.target.value });
  };
  
  // Obsługa zmiany kategorii
  const handleCategoriesChange = (event, newValue) => {
    onFilterChange({ categories: newValue });
  };

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h6">Filtry raportów</Typography>
        <Button
          variant="outlined"
          startIcon={<FilterListIcon />}
          onClick={toggleFilters}
        >
          {showFilters ? 'Ukryj filtry' : 'Pokaż filtry'}
        </Button>
      </Box>
      
      {showFilters && (
        <Box sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            {/* Okres raportu */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="period-label">Okres</InputLabel>
                <Select
                  labelId="period-label"
                  id="period"
                  value={filters.period}
                  label="Okres"
                  onChange={handlePeriodChange}
                >
                  <MenuItem value="month">Miesiąc</MenuItem>
                  <MenuItem value="year">Rok</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            {/* Rok */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="year-label">Rok</InputLabel>
                <Select
                  labelId="year-label"
                  id="year"
                  value={filters.year}
                  label="Rok"
                  onChange={handleYearChange}
                >
                  {years.map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            
            {/* Miesiąc (widoczny tylko gdy okres = miesiąc) */}
            {filters.period === 'month' && (
              <Grid item xs={12} sm={6} md={3}>
                <FormControl fullWidth size="small">
                  <InputLabel id="month-label">Miesiąc</InputLabel>
                  <Select
                    labelId="month-label"
                    id="month"
                    value={filters.month}
                    label="Miesiąc"
                    onChange={handleMonthChange}
                  >
                    {months.map(month => (
                      <MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            
            {/* Porównaj z */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth size="small">
                <InputLabel id="compare-label">Porównaj z</InputLabel>
                <Select
                  labelId="compare-label"
                  id="compare"
                  value={filters.compareWith}
                  label="Porównaj z"
                  onChange={handleCompareWithChange}
                >
                  <MenuItem value="previous">Poprzedni okres</MenuItem>
                  <MenuItem value="last-year">Ten sam okres rok temu</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            
            {/* Kategorie */}
            <Grid item xs={12}>
              <Autocomplete
                multiple
                id="categories-filter"
                options={availableCategories}
                value={filters.categories}
                onChange={handleCategoriesChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    label="Kategorie (wszystkie jeśli nie wybrano)"
                    size="small"
                  />
                )}
                size="small"
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip label={option} size="small" {...getTagProps({ index })} />
                  ))
                }
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
}

export default ReportFilters;